import {
  getCookie,
  initClientScript,
  sendIdentityByEmailEvent,
  sendViewEvent,
  setCookie,
} from 'lib/sitecore/sitecore-cdp';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { ExtendedSitecoreContext } from 'lib/sitecore/sitecore-context';
import { getHostName } from 'lib/sitecore/utils';

const SCAuthcdp = (): JSX.Element => {
  // Fail out if we don't have any fields
  const { data: session } = useSession();
  const cdpClientKey = process.env.CDP_CLIENT_KEY || 'nmduatawv6g974ig49qf7suh5wafcvl7';
  const cdpApiToken = process.env.CDP_API_TOKEN || '9EqExvT980b27xNjgdNnpoUpEisEqroa';
  const cdpTarget = process.env.CDP_TARGET || 'https://api-us.boxever.com/v1.2';
  const cdpDomainCookie = getHostName(process.env.PUBLIC_URL || 'http://localhost:3000');
  const cdpPointOfSale = process.env.CDP_POINT_OF_SALE || 'BeConnected-local';
  const sitecoreContext = useSitecoreContext();
  const contextItem = sitecoreContext.sitecoreContext as ExtendedSitecoreContext;
  const PageUrl = contextItem.itemPath || '';
  const email = session?.user?.email || '';
  const pageState = contextItem.pageState || '';
  const fullName = session?.user?.name || '';
  const firstName = fullName.substring(0, fullName.indexOf(' '));
  const lastName = fullName.substring(fullName.indexOf(' ') + 1);
  let authData = '';
  let identityDataLoaded = false as boolean;
  if (session?.authz_site) {
    authData = (session?.authz_site as string[]).join();
  }
  if (email.length !== 0 && authData.length !== 0 && PageUrl.length !== 0) {
    identityDataLoaded = true;
  }
  useEffect(() => {
    if (pageState === 'normal') {
      initClientScript(
        cdpClientKey,
        cdpDomainCookie,
        cdpTarget,
        '1.4.9',
        cdpPointOfSale,
        'https://d35vb5cccm4xzp.cloudfront.net',
        { LogEvents: true, Currency: 'USD', Language: 'EN', Channel: 'WEB' }
      );
    }
  });

  useEffect(() => {
    if (identityDataLoaded && pageState === 'normal') {
      if (getCookie('cdpi') !== email) {
        sendIdentityByEmailEvent(
          PageUrl,
          email,
          cdpClientKey,
          cdpApiToken,
          '',
          firstName,
          authData,
          lastName
        );
      }
      setCookie('cdpi', email, 19); // setting 19 mins for cookie to expire
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identityDataLoaded]);
  useEffect(() => {
    if (PageUrl.length !== 0 && pageState === 'normal') {
      sendViewEvent(PageUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PageUrl]);
  return <></>;
};
const SCcdp = (): JSX.Element => {
  // Fail out if we don't have any fields
  const cdpClientKey = process.env.CDP_CLIENT_KEY || 'nmduatawv6g974ig49qf7suh5wafcvl7';
  const cdpTarget = process.env.CDP_TARGET || 'https://api-us.boxever.com/v1.2';
  const cdpDomainCookie = getHostName(process.env.PUBLIC_URL || 'http://localhost:3000');
  const cdpPointOfSale = process.env.CDP_POINT_OF_SALE || 'BeConnected-local';
  const sitecoreContext = useSitecoreContext();
  const contextItem = sitecoreContext.sitecoreContext as ExtendedSitecoreContext;
  const PageUrl = contextItem.itemPath || '';
  const pageState = contextItem.pageState || '';

  useEffect(() => {
    if (pageState === 'normal') {
      initClientScript(
        cdpClientKey,
        cdpDomainCookie,
        cdpTarget,
        '1.4.9',
        cdpPointOfSale,
        'https://d35vb5cccm4xzp.cloudfront.net',
        { LogEvents: true, Currency: 'USD', Language: 'EN', Channel: 'WEB' }
      );
    }
  });
  useEffect(() => {
    if (PageUrl.length !== 0 && pageState === 'normal') {
      sendViewEvent(PageUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PageUrl]);
  return <></>;
};

const SCcdpWrapper: React.FC = () => {
  const skipAuthentication = process.env.SKIP_AUTHENTICATION === 'true' ? true : false;
  const sitecoreContext = useSitecoreContext();
  const pageState = sitecoreContext.sitecoreContext.pageState;

  // Don't use when in Sitecore since it'll fail
  if (pageState === 'normal') {
    if (skipAuthentication) {
      return <SCcdp />;
    }
    return <SCAuthcdp />;
  }

  return <></>;
};

export default SCcdpWrapper;
